import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { AuthorizationPipe } from "./../../common/pipes/authorization.pipe";
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CommonConstant } from '../../shared/constants/common.constants';
import { CacheService } from "../../shared/services/cache.service";
import { Router } from '@angular/router';
import { CommonService } from "../services/common.service";
import { StoreService } from '../services/store.service';
import { Permission } from "../../common/enums/permission.enum";
import { environment } from "./../../../environments/environment";
import { UserInfo } from '../interface/user-info.interface';
import { MessageService } from "../services/message.service";
import { AccessLevel } from "../../common/enums/access-level.enum";

@Component({
  selector: "app-main-menu-bar",
  templateUrl: "../templates/template1/views/app-main-menu-bar.component.html",
  styleUrls: ["../templates/template1/themes/default/CSS/scroll.css",
  "../templates/template1/themes/default/CSS/app-main-menu-bar.less"],
  providers: [AuthorizationPipe]
})
export class AppMainMenuBarComponent implements OnInit {

  AdminPermissions: any[] = [Permission.MANAGE_DEPARTMENT_VIEW,Permission.MANAGE_DEPARTMENT_EDIT,Permission.MANAGE_DEPARTMENT_CREATE];

  TicketsPermission: any[] = [Permission.MANAGE_TICKETS_VIEW];

  POSOrderPermission: any[] = [Permission.POS_ORDER_MANAGE,Permission.POS_ORDER_CREATE];

  accountSubNav: boolean = false;
  hideHomeSubNav: boolean = false;
  showSystem: boolean = false
  linkSubNav: boolean = false;
  catalogSubNav: boolean = false; 
  showUserAdmin: boolean = false;
  openAdmin: boolean = false;
  showUserAdministraion: boolean = false;
  showStores: boolean = false;
  showStoreDetails: boolean = false;
  storeName: String;
  active: number;
  sideMenu: any;
  openMenu: boolean = true;
  activeConfig: Number;
  showConfiguration: boolean = false;
  customerServiceSubNav: boolean = false;
  customerServiceTicketsSubNav: boolean = false;
  showShipping: boolean = false;
  @Output('openMenuEmit')
  openMenuEmit = new EventEmitter<boolean>();
  userInfo: UserInfo;
  storeId: number = 0;
  data: boolean = false;
  eventsSubMenu: boolean = false;
  eventId: number;
  eventStoreId: number;
  viewAdminPermission:boolean;
  viewPOSOrderPermission: boolean;
  viewTicketDashboardPermission:boolean;
   

  public store: any = {
    storeId: Number,
    storeName: String,
    isoCodeThree: String,
  };

  searchClicked1: boolean;
  ticketPermissions:boolean;
  permissions: any = Permission;
  hasOrderPermissions:boolean;
  FBOManagerTicketPermissions:number[]=[
    Permission.MANAGE_TICKETS_CREATE,
    Permission.MANAGE_TICKETS_VIEW 
  ]
  departmentPermissions: Number[] = [

    Permission.MANAGE_DEPARTMENT_CREATE,
    Permission.MANAGE_DEPARTMENT_VIEW,
    Permission.MANAGE_DEPARTMENT_EDIT,
    Permission.MANAGE_DEPARTMENT_DEACTIVATE,
    Permission.MANAGE_DEPARTMENT_ACTIVATE,

    Permission.MANAGE_DEPARTMENT_TICKETS_ASSIGN,
    Permission.MANAGE_DEPARTMENT_TICKETS_EDIT,
    Permission.MANAGE_DEPARTMENT_TICKETS_SELF_ASSIGN,
    Permission.MANAGE_DEPARTMENT_TICKETS_REASSIGN,
    Permission.MANAGE_DEPARTMENT_TICKETS_CLOSE,
    Permission.MANAGE_DEPARTMENT_TICKETS_RE_OPEN,
    Permission.MANAGE_DEPARTMENT_USERS_VIEW,
    Permission.MANAGE_DEPARTMENT_USERS_EDIT,
    Permission.MANAGE_DEPARTMENT_USERS_ASSIGN,
  ];
  FBOManageOrderPermissions: number[] = [
    Permission.REGULAR_ORDER_CREATE,
    Permission.REGULAR_ORDER_MANAGE
  ];

  FileUploadsPermissions = [
    Permission.BONUS_REISSUE_TICKETS_CREATE,
    Permission.MANAGE_RECOGNITION_DATA_UPLOAD,
    Permission.CREATE_JAPAN_DATA
  ];
  hasAccessForFileUploads = false;
  enableFileUploads = false;


  
  reportsPermission = [
    Permission.MANAGE_REPORTS,
    Permission.RUN_REPORTS,
    Permission.INVOICE_PRINTING
  ];
  hasAccessForReports = false;

  bonusManagementPermission: any[] = [Permission.BOUNS_MANAGEMENT_CONSOLE];
  hasAccessForBonus: boolean = false;

  constructor(
    private router: Router,
    private _commonService: CommonService,
    private _cacheService: CacheService,
    private _storeService: StoreService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
     this.userInfo = this._cacheService.get(CacheKey.UserInfo);
     this.ticketPermissions = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManagerTicketPermissions + "]"),AccessLevel.Customer_Service);
     this.hasOrderPermissions = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageOrderPermissions + "]"),AccessLevel.Customer_Service);
     this.viewAdminPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.AdminPermissions[0] + "]"),AccessLevel.Account); 
     this.viewTicketDashboardPermission=this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.TicketsPermission[0] + "]"),AccessLevel.Customer_Service); 
     this.viewPOSOrderPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.POSOrderPermission + "]"),AccessLevel.Customer_Service);
     this.hasAccessForFileUploads = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FileUploadsPermissions + "]"),AccessLevel.Customer_Service);
     this.enableFileUploads = environment.enableFileUploads;
     const hasManageReportsPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.reportsPermission[0] + "]"),AccessLevel.Customer_Service);
     const hasRunReportsPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.reportsPermission[1] + "]"),AccessLevel.Customer_Service);
     const hasInvoicePrintingPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.reportsPermission[2] + "]"),AccessLevel.Customer_Service);
     this.hasAccessForReports = hasManageReportsPermission && (hasRunReportsPermission || hasInvoicePrintingPermission);
     if(this.userInfo && this.userInfo.userName !== "superadmin"){
      this.hasAccessForBonus = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.bonusManagementPermission + "]"),AccessLevel.Customer_Service);
     }
  }

  /**
   * to get side menu
   */
  sideMenuBar(): void {
    this._commonService.getSideMenuBar().subscribe(response => {
      if (response) {
        this.sideMenu = response;
      }
    })
  }

  activate(path: any) {
    if (path == "/admin/users") {
      this.showUserAdmin = true;
      this.active = 1;
      this._cacheService.remove(CacheKey.UserSearch);
      this._cacheService.remove(CacheKey.RoleSearch);
    }
    else if (path == "/admin/roles") {
      this.showUserAdmin = true;
      this.active = 2;
      this._cacheService.remove(CacheKey.UserSearch);
      this._cacheService.remove(CacheKey.RoleSearch);
    }
    else if (path == "/admin/permissions") {
      this.showUserAdmin = true;
      this.active = 3;
      this._cacheService.remove(CacheKey.UserSearch);
      this._cacheService.remove(CacheKey.RoleSearch);
    }
  }
 
  activeConfiguration(path: any) {
    if (path == "/admin/configuration/businessentities") {
      this.showConfiguration = true;
      this.activeConfig = 1;
    }
    else if (path == "/admin/configuration/countries") {
      this.showConfiguration = true;
      this.activeConfig = 2;
    }
    else if (path == "/admin/configuration/currencies") {
      this.showConfiguration = true;
      this.activeConfig = 3;
    }
    else if (path == "/admin/configuration/cultures") {
      this.showConfiguration = true;
      this.activeConfig = 4;
    }
    else if (path == "/admin/configuration/languages") {
      this.showConfiguration = true;
      this.activeConfig = 5;
    }
  }

  configurationClick() {
    this.showConfiguration = !this.showConfiguration;
  }

  openMenuBlock() {
    this.openMenu = !this.openMenu;
    this.openMenuEmit.emit(this.openMenu);
  }

  hideConfigBlock() {
    this.openMenu = !this.openMenu;
    this.openMenuEmit.emit(this.linkSubNav);
  }

  hidestoresBlock() {
    this.openMenu = !this.openMenu;
    this.openMenuEmit.emit(this.showStoreDetails);
  }

  hidecatalogBlock() {
    this.openMenu = !this.openMenu;
    this.openMenuEmit.emit(this.catalogSubNav);
  }

  hideuserAdminBlock() {
    this.openMenu = !this.openMenu;
    this.openMenuEmit.emit(this.showUserAdministraion);
  }

  goToConfigurations() {
    this.linkSubNav = !this.linkSubNav;
    if (!this.openMenu) {
      this.openMenu = !this.openMenu;

      this.openMenuEmit.emit(this.openMenu);
    }
    this._cacheService.set(CacheKey.SideMenuPosition, CommonConstant.System_Configuration);

  }

  back() {

    if (this.catalogSubNav && this.storeId == 0) {
      this.catalogSubNav = false;
      this.openMenu = true;
      return;
    }
    let storeId = 0;
    this.storeName = "";
    this._storeService.changeStore(0);
    this._storeService.changeStoreName("");
    this.hideHomeSubNav = false;
    this.linkSubNav = false;
    this.accountSubNav = false;
    this.showSystem = false;
    this.showUserAdministraion = false;
    this.showStores = false;
    this.showStoreDetails = false;
    this.customerServiceSubNav = false;
    this.customerServiceTicketsSubNav = false;
    this.eventsSubMenu = false;
    this.router.navigate(['/admin/dashboard']);
  }

  navigate() {
    this.hideHomeSubNav = false;
    this.linkSubNav = false;
    this.catalogSubNav = false;
    this.accountSubNav = false;
    this.showSystem = false;
    this.showUserAdministraion = false;
    this.showStores = false;
    this.showStoreDetails = false;
    this.customerServiceSubNav = false;
    this.customerServiceTicketsSubNav = false;
  }


  backuserAdminist() {
    this.hideHomeSubNav = false;
    this.linkSubNav = true;
    this.catalogSubNav = false;
    this.showStoreDetails = false;
    this.accountSubNav = false;
    this.showSystem = false;
    this.showStores = false;
    this.showUserAdministraion = false;
    this.customerServiceSubNav = false;
    this.customerServiceTicketsSubNav = false;
    this.openMenu = true;
  }

  goToStoreList() {
    this.hideHomeSubNav = false;
    this.linkSubNav = false;
    this.catalogSubNav = false;
    this.showStoreDetails = false;
    this.accountSubNav = false;
    this.showSystem = false;
    this.showStores = true;
    this.showUserAdministraion = false;
    this.customerServiceSubNav = false;
    this.customerServiceTicketsSubNav = false;
    this.openMenu = true;
  }


  onCustomerServiceBack() {
    this.customerServiceSubNav = true;
    this.customerServiceTicketsSubNav = false;
    if (!this.openMenu) {
      this.openMenu = !this.openMenu;
      this.openMenuEmit.emit(this.openMenu);
    }
    this._cacheService.set(CacheKey.SideMenuPosition, CommonConstant.Customer_Service);
    this.router.navigate(['/customerservice/search']);
  }

  onCustomerService() {
    this.customerServiceSubNav = !this.customerServiceSubNav;
    this.customerServiceTicketsSubNav = false;
    if (!this.openMenu) {
      this.openMenu = !this.openMenu;
      this.openMenuEmit.emit(this.openMenu);
    }
    this._cacheService.set(CacheKey.SideMenuPosition, CommonConstant.Customer_Service);
    this.router.navigate(['/customerservice/search']);
  }

  ticketsClicked() {

    this.customerServiceTicketsSubNav = !this.customerServiceTicketsSubNav;
    if (!this.openMenu) {
      this.openMenu = !this.openMenu;
      this.openMenuEmit.emit(this.openMenu);
    }
    this._cacheService.set(CacheKey.SideMenuPosition, CommonConstant.Customer_Service);
    this.router.navigate(['/customerservice/ticket/dashboard/worktickets']);
  }
  departmentClicked(){
    this.searchClicked1=true;
    this.router.navigate(['/customerservice/departments/search']);
  }
  searchClicked(){
    this.searchClicked1=true;
    this.router.navigate(['/customerservice/search']);

  }
  workticketsClicked(){
    this.searchClicked1=true;
    this.router.navigate(['/customerservice/ticket/dashboard/worktickets']);
  }
  disputeTicketsClicked(){
    this.searchClicked1=true;
    this.router.navigate(['/customerservice/ticket/dashboard/disputetickets']);
  }
  onAccountSettings() {
    this.accountSubNav = !this.accountSubNav;
    if (!this.openMenu) {
      this.openMenu = !this.openMenu;
      this.openMenuEmit.emit(this.openMenu);
    }
    this._cacheService.set(CacheKey.SideMenuPosition, CommonConstant.Account_Settings);
    this.router.navigate(['/admin/useradministration/userprofile']);
  }

  onSystem() {
    this.showSystem = !this.showSystem;
    if (!this.openMenu) {
      this.openMenu = !this.openMenu;
      this.openMenuEmit.emit(this.openMenu);
    }
  }


  countrySelected() {
    this.showStoreDetails = !this.showStoreDetails;
    this.router.navigate(['admin/store/summary', this.storeId]);
  }

 
  clearRetain() {
  
  }


  isStoresPermissionAvailable(): Boolean {
    let userInfo = this._cacheService.get(CacheKey.UserInfo);

    if (userInfo.hasSystemRole) {
      return true;
    }
    else {
      let manageStorePermissions: Number[] = [Permission.MANAGE_STORE_CREATE, Permission.MANAGE_STORE_VIEW, Permission.MANAGE_STORE_EDIT, Permission.MANAGE_STORE_DELETE];
      let userStorePermissions: any[] = userInfo.privileges.stores;
      let userAccountPermissions: any[] = userInfo.privileges.account;
      if (userAccountPermissions && userAccountPermissions.length > 0 && userAccountPermissions.some(item => manageStorePermissions.indexOf(+item) >= 0)) {
        return true;
      }
      else if (userStorePermissions && userStorePermissions.length > 0) {
        return true;
      }
      return false;
    }
  }

  isDepartmentPermissionAvailable(): Boolean {

    let userInfo: UserInfo = this._cacheService.get(CacheKey.UserInfo);
    if (userInfo.hasSystemRole) {
      return true;
    }
    else {
      let manageDepartmentPermissions: Number[] = [Permission.MANAGE_DEPARTMENT_CREATE, Permission.MANAGE_DEPARTMENT_VIEW, Permission.MANAGE_DEPARTMENT_EDIT, Permission.MANAGE_DEPARTMENT_DEACTIVATE, Permission.MANAGE_DEPARTMENT_ACTIVATE];
      let userDepartmentPermissions: any[] = userInfo.privileges.departments;
      let userAccountPermissions: any[] = userInfo.privileges.account;
      if (userAccountPermissions && userAccountPermissions.length > 0 && userAccountPermissions.some(item => manageDepartmentPermissions.indexOf(+item) >= 0)) {
        return true;
      }
      else if (userDepartmentPermissions && userDepartmentPermissions.length > 0) {
        return true;
      }
      return false;
    }
  }

  isConfigurationPermissionAvailable(){
    let userInfo: UserInfo = this._cacheService.get(CacheKey.UserInfo);
    if (userInfo.hasSystemRole) {
      return true;
    }
    else {
      let manageConfigurationPermissions: Number[] = [Permission.MANAGE_DEPARTMENT_CREATE, Permission.MANAGE_DEPARTMENT_VIEW, Permission.MANAGE_DEPARTMENT_EDIT, Permission.MANAGE_DEPARTMENT_DEACTIVATE];
      let userDepartmentPermissions: any[] = userInfo.privileges.departments;
      let userAccountPermissions: any[] = userInfo.privileges.account;
      if (userAccountPermissions && userAccountPermissions.length > 0 && userAccountPermissions.some(item => manageConfigurationPermissions.indexOf(+item) >= 0)) {
        return true;
      }
      return false;
    }
  }



  clearSearchRetain() {
    this._cacheService.remove(CacheKey.UserSearch);
    this._cacheService.remove(CacheKey.DocumentLibrary);
    this._cacheService.remove(CacheKey.StoreUserSearch);
    this._cacheService.remove(CacheKey.RoleSearch);
    this._cacheService.remove(CacheKey.LanguagesSearch);
    this._cacheService.remove(CacheKey.BusinessEntitySearch);
    this._cacheService.remove(CacheKey.CountriesSearch);
    this._cacheService.remove(CacheKey.CurrenciesSearch);
    this._cacheService.remove(CacheKey.MenuSearch);
    this._cacheService.remove(CacheKey.PaymentMethodSearch);
    this._cacheService.remove(CacheKey.PaymentProcessorSearch);
    this._cacheService.remove(CacheKey.EventSearch);
  };

  showSpecificMenu(menuText: String) {

    if (menuText && menuText != "") {

      this.hideHomeSubNav = false;
      this.showSystem = false;
      this.showConfiguration = false;
      this.openAdmin = false;
      this.catalogSubNav = ((menuText === CommonConstant.Catalog_Stores || (menuText === CommonConstant.Catalog_Details)) ? true : false);
      this.accountSubNav = (menuText === CommonConstant.Account_Settings ? true : false);
      this.linkSubNav = (menuText === CommonConstant.System_Configuration ? true : false);
      this.showUserAdministraion = (menuText === CommonConstant.User_Administration ? true : false);
      this.showStores = ((menuText === CommonConstant.Stores) ? true : false);
      this.customerServiceSubNav = (menuText === CommonConstant.Customer_Service ? true : false);
      this.showShipping = (menuText === CommonConstant.Shipping ? true : false);
      this.showStoreDetails = ((menuText === CommonConstant.Store_Details) ? true : false);

      this.store = this._cacheService.get(CacheKey.Store);
      if (this.store) {
        this.storeName = this.store.storeName;
        this.storeId = this.store.storeId;
      }
      else {
        this.storeId = 0;
        this.storeName = '';
      }
    }
    else {
      this.catalogSubNav = false;
      this.hideHomeSubNav = false;
      this.linkSubNav = false;
      this.accountSubNav = false;
      this.showSystem = false;
      this.showConfiguration = false;
      this.openAdmin = false;
      this.showUserAdministraion = false;
      this.showStores = false;
      this.showStoreDetails = false;
      this.customerServiceSubNav = false;
      this.showShipping = false;
      this.storeId = 0;
      this.storeName = '';
    }
  }



  /**
    * To show Events sub menu
    */
  subscribeEventsSubmenuFlag() {
    this.messageService.getEventsTab().subscribe((data: any) => {
      if (data && data.showEventtab) {
        this.eventId = data.eventId;
        this.eventStoreId = data.storeId;
        this.eventsSubMenu = true;
        if (!this.openMenu) {
          this.openMenu = !this.openMenu;
          this.openMenuEmit.emit(this.openMenu);
        }
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/app-main-menu-bar.component.ts